import _ from 'underscore'

function GoogleMapsCustomOverlay(lat, lng, map, onMarkerClicked, args) {
  this.div = null;
  this.latlng = new google.maps.LatLng(lat, lng);
  this.args = args;
  this.setMap(map);
  this.onMarkerClicked = onMarkerClicked;
}

GoogleMapsCustomOverlay.prototype = new google.maps.OverlayView();

GoogleMapsCustomOverlay.prototype.onAdd = function() {
  var div = document.createElement('div');

  div.className = this.args.className;
  div.style.position = 'absolute';
  div.style.cursor = 'pointer';

  if (typeof(this.args.overlayIndex) !== 'undefined') {
    div.dataset.overlay_index = this.args.overlayIndex;
    div.innerHTML = this.args.overlayIndex;
  }

  this.div = div;

  google.maps.event.addDomListener(div, 'click', _.bind(function(event) {
    this.onMarkerClicked(event.target);
    google.maps.event.trigger(this, 'click');
  }, this));

  var panes = this.getPanes();
  panes.overlayImage.appendChild(this.div);
};

//
// This method will be called each time we zoom or change the center or map type.
//
GoogleMapsCustomOverlay.prototype.draw = function() {
  var overlayProjection = this.getProjection();
  var point = overlayProjection.fromLatLngToDivPixel(this.latlng);

  var div = this.div;
  div.style.left = point.x + 'px';
  div.style.top = point.y + 'px';
};

GoogleMapsCustomOverlay.prototype.onRemove = function() {
  this.div.parentNode.removeChild(this.div);
};

export default GoogleMapsCustomOverlay
